import i18n from "@/language/i18n";
import HOLIDAY_WIDGETS from "../widgets/HOLIDAY_WIDGETS";

const HOLIDAY_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    HOLIDAYS_MODULE_WINDOW_ID: 'holidays',
    HOLIDAY_ENTITLEMENT_MODULE_WINDOW_ID: 'holidayEntitlement',
    HOLIDAY_ENTITLEMENTS_MODULE_WINDOW_ID: 'holidayEntitlements',
    DEPUTIES_MODULE_WINDOW_ID: 'holidaydeputies',
    APPROVALS_MODULE_WINDOW_ID: 'holidayapprovals',
    HOLIDAY_BAN_MODULE_WINDOW_ID: 'holidaybans'
});

export { HOLIDAY_MODULE_WINDOW_IDENTIFIER };

export default {
    HOLIDAY_GROUP_WRAPPER: {
        type: 'group',
        id: 'holidays',
        label: i18n.t('ModuleRegistry.groups.holidays.name'),
        children: [],
        icon: '$wCamera',
        sidebarIcon: '$wNavHolidays'
    },
    CHILDREN: {
        HOLIDAYS_MODULE: {
            type: 'module',
            id: 'holidays',
            windowIdentifierType: HOLIDAY_MODULE_WINDOW_IDENTIFIER.HOLIDAYS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.holidays.holidaysView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/holidays',
            globalSearch: {
              index: 'holidays',
              presentation: i18n.t('ModuleRegistry.groups.holidays.holidaysView.presentation'),
              component: 'HolidayItem.vue'
            },
            widgets: HOLIDAY_WIDGETS.HOLIDAYS_WIDGETS
        },
        HOLIDAY_ENTITLEMENT_MODULE: {
            type: 'module',
            id: 'holidayEntitlement',
            windowIdentifierType: HOLIDAY_MODULE_WINDOW_IDENTIFIER.HOLIDAY_ENTITLEMENT_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.holidays.holidayEntitlementView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/holidayEntitlement',
            widgets: HOLIDAY_WIDGETS.HOLIDAYS_OVERVIEW_WIDGETS
        },
        HOLIDAY_ENTITLEMENTS_MODULE: {
            type: 'module',
            id: 'holidayEntitlements',
            windowIdentifierType: HOLIDAY_MODULE_WINDOW_IDENTIFIER.HOLIDAY_ENTITLEMENTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.holidays.holidayEntitlementsView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/holidayEntitlements',
            widgets: HOLIDAY_WIDGETS.HOLIDAYS_OVERVIEW_WIDGETS
        },
        DEPUTIES_MODULE: {
            type: 'module',
            id: 'deputies',
            windowIdentifierType: HOLIDAY_MODULE_WINDOW_IDENTIFIER.DEPUTIES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.holidays.deputies.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/holidaydeputies',
            widgets: HOLIDAY_WIDGETS.DEPUTIES_WIDGETS
        },
        APPROVALS_MODULE: {
            type: 'module',
            id: 'approval',
            windowIdentifierType: HOLIDAY_MODULE_WINDOW_IDENTIFIER.APPROVALS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.holidays.approvals.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/holidayapprovals',
            widgets: HOLIDAY_WIDGETS.APPROVALS_MODULE
        },
        HOLIDAY_BAN_MODULE: {
            type: 'module',
            id: 'holidaybans',
            windowIdentifierType: HOLIDAY_MODULE_WINDOW_IDENTIFIER.HOLIDAY_BAN_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.holidays.holidayBanView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/holidaybans',
        },
        HOLIDAY_BAN_CALENDAR_MODULE: {
            type: 'module',
            id: 'holidayBanCalendar',
            label: i18n.t('ModuleRegistry.groups.holidays.holidayBanCalendarView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/holiday-ban-years',
        }
    }
}
